import { render, staticRenderFns } from "./BCXSwitch.vue?vue&type=template&id=58fe4720"
import script from "./BCXSwitch.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXSwitch.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports